module.exports = __webpack_public_path__ + "static/media/web-logo.817e95a1.jpg";